
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'contracts-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'contracts-bundle')

export default [
  {
    name: 'contract.index',
    path: '/contracts',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'contract.new',
        path: 'create',
        component: Form,
        meta: { requiresAuth: true }
      },
      {
        name: 'contract.edit',
        path: ':id/edit',
        component: Form,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/contracts/routes.js